const BASEURL = "https://api.sikamai.com:5000/admin";

export default BASEURL;
